module.exports = __webpack_public_path__ + "img/banner-35.3aadcbe2.jpg";